import { trigger, state, style, transition, animate } from '@angular/animations'
import { Component, EventEmitter, Input, Output } from '@angular/core'

@Component({
  selector: 'app-dynamic-modal',
  templateUrl: './dynamic-modal.component.html',
  styleUrls: ['./dynamic-modal.component.scss'],
  animations: [
    trigger('fadeSlide', [
      state(
        'void',
        style({
          opacity: 0,
          transform: 'translateY(-20px)'
        })
      ),
      state(
        '*',
        style({
          opacity: 1,
          transform: 'translateY(0)'
        })
      ),
      transition('void <=> *', animate('300ms ease-in-out'))
    ])
  ]
})
export class DynamicModalComponent {
  @Input() isVisible: boolean = false
  @Input() title: string = ''
  @Input() position: 'fullscreen' | 'centered' | 'left' | 'right' = 'centered'
  @Input() bodyTemplate!: any
  @Output() close = new EventEmitter<void>()

  onClose() {
    this.close.emit()
  }
}
